import React from 'react'
import { CircularProgress } from '@mui/material'
import useMediaHandle from '../../../../../hooks/useMediaHandle'

const SimpleAudioPlayer = ({ media }) => {
  const { startLoad, srcURL } = useMediaHandle({ media })

  // Download file
  React.useEffect(() => {
    startLoad()
  }, [startLoad])

  if (!srcURL) {
    return <CircularProgress style={{ position: 'relative' }} />
  }

  return <audio controls style={{ height: 30, width: 240 }} src={srcURL} />
}

export default SimpleAudioPlayer
